<template>
  <main class="wrapper">
    <app-document>
      <h1>Договор на сервис</h1>
      <template v-slot:pdf>
        <a href="https://drive.google.com/file/d/1jKuMBoQlzU9kj5Fc-UV3KeQmPMn6yG-9/view?usp=sharing" target="_blank">
          <img src="../img/pdf.webp" alt="иконка пдф">
        </a>
      </template>
      <template v-slot:word>
        <a href="https://drive.google.com/file/d/1Xm0ElMiaWgeW57iW7CKz2-6dQAjQZrkV/view?usp=sharing" target="_blank">
          <img src="../img/word.webp" alt="иконка ворд">
        </a>
      </template>
    </app-document>
    <app-document>
      <h1>Заявление на заключение договора ТО</h1>
      <template v-slot:pdf>
        <a href="https://drive.google.com/file/d/1_Y-l9TNgNQl9BlSFfpwxHnElhYyFKDHL/view?usp=sharing" target="_blank">
          <img src="../img/pdf.webp" alt="иконка пдф">
        </a>
      </template>
      <template v-slot:word>
        <a href="https://drive.google.com/file/d/19iAQamUa9CXKBCChqOBF1E-pJ82DmTay/view?usp=sharing" target="_blank">
          <img src="../img/word.webp" alt="иконка ворд">
        </a>
      </template>
    </app-document>
    <app-document>
      <h1>Образец гарантийного талона</h1>
      <template v-slot:pdf>
        <a href="https://drive.google.com/file/d/1rl4dPku7rDhcspoLFZ2Y1DAmCMQqD1Ye/view?usp=sharing" target="_blank">
          <img src="../img/pdf.webp" alt="иконка пдф">
        </a>
      </template>
    </app-document>
    <app-document>
      <h1>Постановление №410 от 14.05.2013</h1>
      <template v-slot:pdf>
        <a href="https://drive.google.com/file/d/1jIbNVcKRwuLVAH9ZV_H5g0St-xnuHlE0/view?usp=sharing" target="_blank">
          <img src="../img/pdf.webp" alt="иконка пдф">
        </a>
      </template>
      <template v-slot:word>
        <a href="https://drive.google.com/file/d/1nLeXGHpihX28JuBecbRxTtTVP9tc-HcV/view?usp=sharing" target="_blank">
          <img src="../img/word.webp" alt="иконка ворд">
        </a>
      </template>
    </app-document>
    <app-document>
      <h1>Правила поставки газа</h1>
      <template v-slot:pdf>
        <a href="https://drive.google.com/file/d/199mfYhWAGeYLkeltCvDvsPJQAP90HLFM/view?usp=sharing" target="_blank">
          <img src="../img/pdf.webp" alt="иконка пдф">
        </a>
      </template>
      <template v-slot:word>
        <a href="https://drive.google.com/file/d/1Bq2HVPIqUIegjzEgzn4-XGQmb8FRaPq4/view?usp=sharing" target="_blank">
          <img src="../img/word.webp" alt="иконка ворд">
        </a>
      </template>
    </app-document>
    <app-document>
      <h1>Расценки на монтаж и ТО</h1>
      <template v-slot:pdf>
        <a href="https://drive.google.com/file/d/1kRjpwLmFPN3UgTxE_Txek0Ep6Mye-GKn/view?usp=sharing" target="_blank">
          <img src="../img/pdf.webp" alt="иконка пдф">
        </a>
      </template>
    </app-document>
    <app-document>
      <h1>Ремонт чугунного теплообменника</h1>
      <template v-slot:pdf>
        <a href="https://drive.google.com/file/d/1jLNGt0n7t4NNOSY454LpxnwkEZ3fvf1u/view?usp=sharing" target="_blank">
          <img src="../img/pdf.webp" alt="иконка пдф">
        </a>
      </template>
    </app-document>
  </main>
</template>

<script>
  import AppDocument from "@/components/AppDocument";

  export default {
    components: {AppDocument}
  }
</script>

<style scoped>
  .wrapper {
    margin: 30px auto;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-around;
    max-width: 1800px;
  }

  img {
    width: 80px;
    height: 80px;
  }

  h1 {
    font-family: "Poppins", sans-serif !important;
    color: black;
    font-size: 2.2em;
  }

  @media (min-width: 1300px) {
    h1 {
      font-size: 1.8em;
    }

    img{
      width: 50px;
      height: 50px;
      margin-left: 20px;
      margin-right: 20px;
    }
  }

  @media (max-width: 1300px) {
    h1 {
      font-size: 1.3em;
    }

    img{
      width: 50px;
      height: 50px;
      margin-left: 20px;
      margin-right: 20px;
    }
  }

  @media (max-width: 600px) {
    h1 {
      font-size: 1.2em;
    }
  }


</style>